module.exports = "/_next/static/images/2a10d88931b2df123e9f38c22a66d0d4-card-green-check-icon.svg.webp";